<main class="fadeIn">
    <div class="container-fluid" #focusedElement>
        <div class="row">
            <div class="col-12">
                <div class="header d-flex justify-content-between">
                    <h1><small>&nbsp;</small>Diagnosis Code List</h1>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="filter-body">
                    <div class="filter">
                        <div class="row justify-content-between">
                            <div class="col-10" style="width:85%">

                                <div class="row" [formGroup]="diagnosisfilterForm">
                                    <div class="col-2">
                                        <input type="text" class="form-control" formControlName="version" id="MDSearch"
                                            placeholder="Search by version" appPreventFirstSpace>
                                    </div>
                                    <div class="col-3">
                                        <app-datepicker_v2 formControlName="validity" [field]="feild_startDate">
                                        </app-datepicker_v2>
                                    </div>
                                    <div class="col-2">
                                        <input autocomplete="disabled" class="form-check-input" formControlName="inUse"
                                            type="checkbox" id="inUse">
                                        <label class="form-check-label link" for="inUse">In Use</label>
                                    </div>
                                    <div class="col-2 d-flex">
                                        <button id="btnDrugFilterApply" type="button" class="btn btn-dark-blue"
                                            (click)="filterOnClick()">APPLY</button>
                                        <a class="reset-btn" (click)="resetFilter()"><span></span>Reset</a>
                                    </div>
                                </div>

                            </div>
                            <div class="col" *ngIf="checkPermission(permission.diagnosis.saveDiagnosis)">
                                <button id="btnGroupAddNewDrugList" type="button" data-bs-toggle="modal"
                                    class="btn btn-primary float-end" (click)="addNewDiagnosis()">
                                    ADD New
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="table-container table-responsive">
                    <table class="table table-list">
                        <caption class="d-none">Preferref drug list table body</caption>
                        <thead>
                            <tr>
                                <th scope="col">Version
                                    <span class="sort-order" *ngIf="diagnosisList?.length"
                                        (click)="sortColumn('diaganosisVersion')">
                                        <a class="{{columnSort['diaganosisVersion'].sortType}}"></a>
                                    </span>
                                </th>
                                <th scope="col">Validity<span *ngIf="diagnosisList?.length" class="sort-order"
                                        (click)="sortColumn('activeFrom')"><a
                                            class="{{columnSort['activeFrom'].sortType}}"></a></span>
                                </th>
                                <th scope="col">Description<span *ngIf="diagnosisList?.length" class="sort-order"
                                        (click)="sortColumn('diaganosisVersionDesc')"><a
                                            class="{{columnSort['diaganosisVersionDesc'].sortType}}"></a></span>
                                </th>
                                <th scope="col">Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of diagnosisList">
                                <td>{{item.diaganosisVersion}}</td>
                                <td>{{item?.activeFrom | dateFormat}} - {{item?.expiredOn| dateFormat}}
                                </td>
                                <td>{{ item?.diaganosisVersionDesc || '-'}} </td>
                                <td>
                                    <ul class="actions">

                                        <li>
                                            <a data-bs-toggle="modal" class="edit-icon tool-wrap position-relative"
                                                (click)="showEdit(item)" *ngIf="checkPermission(permission.diagnosis.editDiagnosis)">
                                                <div class="custom-tooltip tooltip-top" role="tooltip">
                                                    <div class="arrow"></div>
                                                    <div class="tooltip-inner" > Edit </div>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a data-bs-toggle="modal" class="view tool-wrap position-relative"
                                                (click)="ShowDetailView(item)" *ngIf="checkPermission(permission.diagnosis.getDiagnosisDetails)">
                                                <div class="custom-tooltip tooltip-top" role="tooltip">
                                                    <div class="arrow"></div>
                                                    <div class="tooltip-inner"> View </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="no-data with-border" *ngIf="!diagnosisList?.length">
                        <img src="./assets/images/icons/no-data-img.svg" alt="">
                        <p>No Results Found</p>
                    </div>
                </div>
                <app-navigation [listLength]="totalCount" [pageNo]="page_no"
                    (currentPageDetail)="currentPageDetail($event)">
                </app-navigation>
            </div>
        </div>
    </div>
</main>
<app-master-add-edit *ngIf="isAddpage" [isEdit]="isEdit" (closeAddEdit)="closeAddEdit($event)"
    [screenType]="'diagnosis'" [selectedVersion]="selectedVersion"></app-master-add-edit>